import React, { FC, useState } from 'react';
import { AmplienceHeaderNavProps } from 'components/amplience/header-nav';
import Drawer from 'components/commercetools-ui/atoms/drawer';
import { cn } from 'helpers/utils/classnames';
import CloseIcon from 'icons/close';
import MenuIcon from 'icons/menu-icon';
import MobileMenu from './content/mobile-menu';

export interface Props {
  className?: string;
  headerNav: AmplienceHeaderNavProps;
}

const HeaderNavigationMobile: FC<Props> = ({ className, headerNav }) => {
  const [showMenu, setShowMenu] = useState(false);

  const showHeaderMenu = () => {
    const banner = document.getElementById('siteNoticeBanner');

    setIsDisplayingBanner(banner !== null);
    setShowMenu(true);
  };

  const hideHeaderMenu = () => {
    setShowMenu(false);
  };
  const [isDisplayingBanner, setIsDisplayingBanner] = useState<boolean>(false);

  return (
    <div className={className}>
      <div className="mr-5 flex size-5 items-center">
        <div onClick={showHeaderMenu}>
          <MenuIcon />
        </div>
      </div>

      {showMenu && (
        <CloseIcon
          className={cn('absolute right-0 top-0 z-[700] mx-auto mt-6 flex w-[10vw] items-center justify-center', {
            '-top-[84px]': isDisplayingBanner,
          })}
          color="white"
        />
      )}
      <Drawer isOpen={showMenu} direction="left" className="w-[90vw] bg-white" onClose={hideHeaderMenu}>
        <MobileMenu headerNav={headerNav} />
      </Drawer>
    </div>
  );
};

export default HeaderNavigationMobile;
